import { render, staticRenderFns } from "./cell-translation-job-name.vue?vue&type=template&id=e9e2fbe0&scoped=true"
import script from "./cell-translation-job-name.ts?vue&type=script&lang=ts&external"
export * from "./cell-translation-job-name.ts?vue&type=script&lang=ts&external"
import style0 from "./cell-translation-job-name.vue?vue&type=style&index=0&id=e9e2fbe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9e2fbe0",
  null
  
)

export default component.exports